/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface PayOpenTableRequest
 */
export interface PayOpenTableRequest {
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    discountCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    paymentProvider: PayOpenTableRequestPaymentProviderEnum;
    /**
     * 
     * @type {number}
     * @memberof PayOpenTableRequest
     */
    amountToPay: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayOpenTableRequest
     */
    askForTip: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PayOpenTableRequest
     */
    unintegratedFields: { [key: string]: string; };
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof PayOpenTableRequest
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableRequest
     */
    deviceId: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PayOpenTableRequest
     */
    orderLineQuantityMap?: { [key: string]: number; };
}


/**
 * @export
 */
export const PayOpenTableRequestPaymentProviderEnum = {
    ADYEN: 'ADYEN',
    SOFTPAY: 'SOFTPAY',
    NETS: 'NETS'
} as const;
export type PayOpenTableRequestPaymentProviderEnum = typeof PayOpenTableRequestPaymentProviderEnum[keyof typeof PayOpenTableRequestPaymentProviderEnum];


/**
 * Check if a given object implements the PayOpenTableRequest interface.
 */
export function instanceOfPayOpenTableRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "orderReference" in value;
    isInstance = isInstance && "paymentProvider" in value;
    isInstance = isInstance && "amountToPay" in value;
    isInstance = isInstance && "askForTip" in value;
    isInstance = isInstance && "unintegratedFields" in value;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "deviceId" in value;

    return isInstance;
}

export function PayOpenTableRequestFromJSON(json: any): PayOpenTableRequest {
    return PayOpenTableRequestFromJSONTyped(json, false);
}

export function PayOpenTableRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayOpenTableRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'orderReference': json['orderReference'],
        'discountCode': !exists(json, 'discountCode') ? undefined : json['discountCode'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'paymentProvider': json['paymentProvider'],
        'amountToPay': json['amountToPay'],
        'askForTip': json['askForTip'],
        'unintegratedFields': json['unintegratedFields'],
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'deviceId': json['deviceId'],
        'orderLineQuantityMap': !exists(json, 'orderLineQuantityMap') ? undefined : json['orderLineQuantityMap'],
    };
}

export function PayOpenTableRequestToJSON(value?: PayOpenTableRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'orderReference': value.orderReference,
        'discountCode': value.discountCode,
        'comment': value.comment,
        'paymentProvider': value.paymentProvider,
        'amountToPay': value.amountToPay,
        'askForTip': value.askForTip,
        'unintegratedFields': value.unintegratedFields,
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'deviceId': value.deviceId,
        'orderLineQuantityMap': value.orderLineQuantityMap,
    };
}

